import React from "react";

import { CertificateIcon, FileOutlineIcon, LinkIcon } from "../../../assets/icons/interface/interface";

function Applications() {
	return (
		<div className="space-y-4">
			<div className="space-y-4 p-6 rounded-md border border-gray-200">
				<div className="flex items-center gap-3">
					<div className="w-[48px]">
						<img className="img-fluid" src="/images/logo.png" alt="Logo" />
					</div>
					<div>
						<h6 className="text-4 font-bold">Frontend Developer</h6>
						<p className="text-sm font-normal">TechCorp</p>
					</div>
				</div>
				<p className="text-sm font-normal text-gray-700">Submitted Feb 13, 2025</p>
				<div className="flex items-center flex-wrap gap-4">
					<div className="flex items-center gap-2 bg-gray-50 px-3 py-1.5 rounded-md text-gray-700">
						<FileOutlineIcon className="w-4 h-4" />
						<span className="text-sm font-normal">Resume_UIUX.pdf</span>
					</div>
					<div className="flex items-center gap-2 bg-gray-50 px-3 py-1.5 rounded-md text-gray-700">
						<LinkIcon className="w-4 h-4" />
						<span className="text-sm font-normal">Portfolio_UIUX.pdf</span>
					</div>
					<div className="flex items-center gap-2 bg-gray-50 px-3 py-1.5 rounded-md text-gray-700">
						<CertificateIcon className="w-4 h-4" />
						<span className="text-sm font-normal">Certificate_UIUX.pdf</span>
					</div>
				</div>
			</div>
			<div className="space-y-4 p-6 rounded-md border border-gray-200">
				<div className="flex items-start gap-3">
					<div className="w-[48px]">
						<img className="img-fluid" src="/images/logo.png" alt="Logo" />
					</div>
					<div>
						<h6 className="text-4 font-bold">Frontend Developer</h6>
						<p className="text-sm font-normal">TechCorp</p>
					</div>
				</div>
				<p className="text-sm font-normal text-gray-700">Submitted Feb 13, 2025</p>
				<div className="flex items-center flex-wrap gap-4">
					<div className="flex items-center gap-2 bg-gray-50 px-3 py-1.5 rounded-md text-gray-700">
						<FileOutlineIcon className="w-4 h-4" />
						<span className="text-sm font-normal">Resume_UIUX.pdf</span>
					</div>
					<div className="flex items-center gap-2 bg-gray-50 px-3 py-1.5 rounded-md text-gray-700">
						<LinkIcon className="w-4 h-4" />
						<span className="text-sm font-normal">Portfolio_UIUX.pdf</span>
					</div>
					<div className="flex items-center gap-2 bg-gray-50 px-3 py-1.5 rounded-md text-gray-700">
						<CertificateIcon className="w-4 h-4" />
						<span className="text-sm font-normal">Certificate_UIUX.pdf</span>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Applications;
